module.exports = __webpack_public_path__ + "static/eddy-8ac93f1445fb861a6bde1afb0c55b401.png";